type Orientation = "landscape" | "portrait";

type Props = {
  value: Orientation;
  onChange: (value: Orientation) => void;
};

export function OrientationRadio({ value, onChange }: Props) {
  return (
    <div className="flex gap-4 mt-4">
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name="orientation"
          value="landscape"
          checked={value === "landscape"}
          onChange={() => onChange("landscape")}
          className="accent-primary"
        />
        <span className="text-sm">Landscape </span>
      </label>

      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="radio"
          name="orientation"
          value="portrait"
          checked={value === "portrait"}
          onChange={() => onChange("portrait")}
          className="accent-primary"
        />
        <span className="text-sm">Portrait </span>
      </label>
    </div>
  );
}
